<template>
    <div>
        <div class="page blogs">
            <!-- BLOGS BANNER -->
            <div class="blogs-banner">
                <div class="blogs-banner-img">
                    <img :src="bannerList[0]?.img || require('@/assets/blogsMb/banner.png')" alt=""></img>
                </div>
                <div class="carousel-information" @click="openInquiryForm">
                    <img src="../../assets/home/xinxi.png" alt="">
                </div>
            </div>
            <!-- BLOGS TABS -->
            <div class="blogs-tabs">
                <button v-for="(tab, index) in tabs" :key="index" :class="['tab', { active: activeTabIndex === index }]"
                    @click="tabClick(index)">
                    {{ tab }}
                </button>
            </div>
            <!-- BLOGS NEWS -->
            <div class="blogs-news">
                <div class="blogs-news-item" v-for="(item, index) in list" :key="index">
                    <div class="item-image">
                        <img :src="item.image" alt=""></img>
                    </div>
                    <div class="item-title">{{ item.title }}</div>
                    <div class="item-content">{{ item.content }}</div>
                    <div class="item-more-bnt" @click="goDetail(item.id)">更多详情</div>
                </div>
            </div>
        </div>
        <!-- <blogsDetail v-else :chidList="chidList"></blogsDetail> -->

    </div>

</template>
<script>
import blogsDetail from '@/page/mobile/blogsDetail.vue';
import { bus } from '@/utils/bus';
import { getNewsList, getBannerListingMobile, getNewsDetail } from '@/api/komo';
export default {
    components: {
        blogsDetail
    },
    data() {
        return {
            isShow: true,
            activeTabIndex: 0,
            tabs: [this.$t('blogs.tabs.Enterprise'), this.$t('blogs.tabs.Industry')],
            list: [],
            bannerList: [],
            list1: [
                {
                    img: require('@/assets/blogs/blogs-1.png'),
                    title: this.$t('blogs.listTitle'),
                    text: this.$t('blogs.listText')
                },
                {
                    img: require('@/assets/blogs/blogs-2.png'),
                    title: this.$t('blogs.listTitle'),
                    text: this.$t('blogs.listText')
                },
                {
                    img: require('@/assets/blogs/blogs-1.png'),
                    title: this.$t('blogs.listTitle'),
                    text: this.$t('blogs.listText')
                }
            ],
            list2: [
                {
                    img: require('@/assets/blogs/blogs-2.png'),
                    title: this.$t('blogs.listTitle'),
                    text: this.$t('blogs.listText')
                },
                {
                    img: require('@/assets/blogs/blogs-1.png'),
                    title: this.$t('blogs.listTitle'),
                    text: this.$t('blogs.listText')
                },
                {
                    img: require('@/assets/blogs/blogs-2.png'),
                    title: this.$t('blogs.listTitle'),
                    text: this.$t('blogs.listText')
                }
            ],
        };
    },
    mounted() {
        // 页面挂载后执行逻辑
        this.list = this.list1;

    },
    created() {
        this.initData();
    },
    methods: {
        async initData() {
            const res1 = await getBannerListingMobile('7')
            this.bannerList = res1?.data?.list || [];
            const res = await getNewsList({ type: this.activeTabIndex === 0 ? 'enterprise' : 'industry', search: '' });
            this.list = res.data?.list;
        },
        // tab 点击
        tabClick(index) {
            this.activeTabIndex = index;
            this.initData();
        },
        openInquiryForm() {
            bus.$emit('inquiry-form', true)
        },
        async goDetail(id) {
            const res = await getNewsDetail(id);
            if (res.error === 0 && res.data) {
                const list = res.data?.list;
                this.$router.push({
                    name: 'detail',
                    params: {
                        list: list
                    }
                });
            }

        }
    }
};
</script>
<style scoped>
.blogs {
    background: #F8F9FC;
}

/* banner */
.blogs-banner {
    width: 100%;
    position: relative;
}

.blogs-banner .blogs-banner-img {
    width: 100%;
}

.blogs-banner-img img {
    width: 100%;
    height: 100%;
}

.blogs-banner .carousel-information {
    position: fixed;
    bottom: 3%;
    right: 3%;
    width: 25vw;
    height: 25vw;
    cursor: pointer;
    z-index: 999;
}

.blogs-banner .carousel-information img {
    width: 100%;
    height: 100%;
}

/* BLOGS TABS */
.blogs-tabs {
    display: flex;
    gap: 8px;
    padding: 20px 12px;
    position: sticky;
    top: 0;
    z-index: 2;
    background: linear-gradient(180deg, #ffffff 70%, transparent);
}

.tab {
    flex: 0 0 auto;
    padding: 8px 14px;
    border-radius: 999px;
    border: 1px solid #dcdcdc;
    background: #fff;
    color: #55635b;
    font-weight: 600;
}

.tab.active {
    background: #e3efe3;
    border-color: #b7d2b7;
    color: #2b3a31;
}

/* BLOGS NEWS */
.blogs-news {
    width: 100%;
    padding: 0 12px;
}

.blogs-news-item {
    width: 100%;
    background: #FFFFFF;
    padding: 10px;
    border-radius: 20px;
    margin-bottom: 20px;
}

.blogs-news-item:last-child {
    margin-bottom: 0;
    /* 最后一个元素取消 margin */
}

.blogs-news-item .item-image {
    width: 100%;
}

.blogs-news-item .item-image img {
    width: 100%;
}

.blogs-news-item .item-title {
    font-size: 5vw;
    font-weight: bold;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    line-height: 5vh;
    margin-top: 3%;
}

.blogs-news-item .item-content {
    font-size: 3vw;
    font-family: MicrosoftYaHei;
    color: #959595;
}

.blogs-news-item .item-more-bnt {
    width: 21%;
    padding: 2% 0;
    border-radius: 30px;
    border: 1px solid #979797;
    font-size: 1rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #1e1e1e;
    margin: 20px 0 10px 0;
}


/* 多媒体自适应 样式 */
/* 1280 1080   */
@media (max-width: 1280px)and (min-width: 960px) {
    .blogs-news-item .item-title {
        line-height: 10vh;
    }
}
</style>